const EventEmitter = require('eventemitter3');

module.exports = new EventEmitter();



// WEBPACK FOOTER //
// ./src/scripts/components/eventhandler.js